import { NgModule } from '@angular/core';
import { AnalyticsDirectivesModule } from '@analytics/events';
import { EffectsModule } from '@ngrx/effects';
import { ModalBodyDirective, ModalComponent } from '@legacy/common-ui-shared';
import { TextInterpolationPipe } from '@core/jss-utils';
import { NgClass } from '@angular/common';
import { RichTextWrapperComponent } from '@legacy/common-ui-utility-components';
import { AutomationIdDirective } from '@innogy/utils-automation-id';

import { ExitFunnelModalEffects } from './+state/exit-funnel/exit-funnel.effects';
import { GenericModalEffects } from './+state/generic-modal.effects';
import { ResidentialModalEffects } from './+state/residential/residential.effects';
import { GenericModalComponent } from './generic-modal.component';

const EFFECTS = [
  GenericModalEffects,
  ExitFunnelModalEffects,
  ResidentialModalEffects,
];
@NgModule({
  imports: [
    AnalyticsDirectivesModule,
    EffectsModule.forFeature(EFFECTS),
    ModalComponent,
    ModalBodyDirective,
    TextInterpolationPipe,
    NgClass,
    RichTextWrapperComponent,
    AutomationIdDirective,
    GenericModalComponent,
  ],
})
export class GenericModalModule {}
